import React from "react";
import * as styles from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";

const USPSection = ({ uspSection }) => {

  return (
    <div className={styles.uspSectionLayout}>
      <div className={styles.titleContainer}>
        {uspSection?.icon && <img srcSet={getImagePath(uspSection?.icon)} className={styles.icon} alt={uspSection.icon.alt}/> }

        <span className={styles.title}>{uspSection?.title}<span className={styles.coloredTitle}>{uspSection?.coloredText}</span>{uspSection?.otherText}</span>
      </div>
      <div className={styles.descriptionContainer}>
        {uspSection?.usp.map((content, key) => {
          const { description, icon } = content;
          return (
            <React.Fragment key={key}>
              <div className={styles.uspContainer}>
                <div className={styles.titleIcon}>
                  <div className={styles.iconImg}> <img src={getImagePath(icon)} alt={icon?.alt} /></div>
                </div>
                <p className={styles.uspDescription}>{description}</p>
              </div>
              <div className={styles.line}></div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default USPSection;